import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import MultipleItemsCard from 'views/declarations/common/MultipleItemsCard';
import useFormUtils from '../../../../../hooks/useFormUtils';
import useHideEntities from '../../../../../hooks/useHideEntities';
import { FormCardContainer } from '../../../common/cards/NewFormCard';
import ContainerIdentificationNumberBlock, {
    containerIdentificationNumberBlockProductValidation,
    containerIdentificationNumberBlockValidation,
} from '../blocks/ContainerIdentificationNumberBlock';
import SealNumberBlock, { sealNumberBlockValidation } from '../blocks/SealNumberBlock';

export const transportEquipmentCardValidation = {
    selfValidators: [sealNumberBlockValidation, containerIdentificationNumberBlockValidation],
};

export const cdsImportTransportEquipmentCardValidation = {
    selfValidators: [containerIdentificationNumberBlockValidation],
};

export const transportEquipmentCardValidationProduct = {
    selfValidators: [containerIdentificationNumberBlockProductValidation],
};

const TransportEquipmentCard: FC<DeclarationFormCardProps & { isProduct?: boolean }> = ({
    isProduct,
    propsPathPrefix,
    viewOnly,
}) => {
    const { t } = useTranslation('form');
    const formik = useFormikContext();
    const { isFormType } = useHideEntities();
    const { formTypeForCds } = useFormUtils();

    return (
        <MultipleItemsCard
            viewOnly={viewOnly}
            title={t('transportEquipment')}
            path={propsPathPrefix ?? 'goodsShipment.consignment.transportEquipment'}
            getFieldProps={formik.getFieldProps}
            getFieldMeta={formik.getFieldMeta}
            getFieldHelpers={formik.getFieldHelpers}
            initialValues={{ id: '', seal: [{ id: '' }] }}
            list={(list) => [
                { field: t('containerIdentificationNumbers'), value: list.id },
                { field: 'Number of seals', value: list.seal?.length.toString() ?? '0' },
            ]}
            condensed
            hidden={isFormType([])}
            refNumber={!(isProduct || formTypeForCds?.includes('IMPORT')) ? ['7/10', '7/18'] : '7/10'}
        >
            {(path) => (
                <FormCardContainer oneColumn>
                    <ContainerIdentificationNumberBlock path={path} />
                    {!isProduct && <SealNumberBlock path={path} hide={isFormType(['IMPORT_H1', 'IMPORT_H2'])} />}
                </FormCardContainer>
            )}
        </MultipleItemsCard>
    );
};
export default TransportEquipmentCard;
